import React, { useMemo, useState } from 'react'
import injectSheet from 'react-jss'
import styles from './presentation-preview.styles'
import { PresentationContext, PresentationStateContext } from './context'
import SlideConstructor from './slide-constructor/slide-constructor'
import withWindowSize from 'pobble-components/dist/with-window-size'
import TabletPortraitPlaceholder from '../tablet-portrait-placeholder/tablet-portrait-placeholder'
import PresentationSkeleton from './presentation-skeleton/presentation-skeleton'
import { usePresentationNavigation } from 'pobble-components/dist/presentation'
import keyBy from 'lodash/keyBy'
import NoItemsPlaceholder from 'pobble-components/dist/no-items-placeholder'

const PresentationPreview = ({
  classes,
  presentation,
  pending,
  windowSize,
  onClose,
  onCopy
}) => {
  const isPortrait = windowSize.orientation === 'portrait'
  const [sidebarOpened, setSidebarOpened] = useState(false)
  const [infoOpened, setInfoOpened] = useState(false)

  const {
    activeSlideIndex,
    activeSlideId,
    nextSlide,
    prevSlide,
    slidePosition
  } = usePresentationNavigation(presentation, { loop: true })

  const slides = useMemo(
    () => (!presentation ? {} : keyBy(presentation.slides, 'id')),
    [presentation]
  )

  const value = useMemo(
    () => ({
      slidePosition,
      activeSlideId,
      activeSlideIndex,
      nextSlide,
      prevSlide,
      toggleSidebar: setSidebarOpened,
      toggleInfo: setInfoOpened,
      onClose,
      onCopy,
      sidebarOpened,
      infoOpened,
      slides
    }),
    [activeSlideId, infoOpened, nextSlide, prevSlide, sidebarOpened, slides] // eslint-disable-line
  )

  return pending || !!presentation ? (
    <PresentationContext.Provider value={presentation}>
      <PresentationStateContext.Provider value={value}>
        {isPortrait && (
          <TabletPortraitPlaceholder className={classes.portraitPlaceholder} />
        )}
        <div className={classes.container}>
          {!activeSlideId && <PresentationSkeleton />}
          {!!activeSlideId && <SlideConstructor />}
        </div>
      </PresentationStateContext.Provider>
    </PresentationContext.Provider>
  ) : (
    <div className={classes.notFound}>
      <NoItemsPlaceholder>
        <p>Sorry, we coulnd't find this lesson</p>
        <p>It may have been deleted or set to private</p>
      </NoItemsPlaceholder>
    </div>
  )
}

export default withWindowSize(injectSheet(styles)(PresentationPreview))
